<template>
  <div v-if="showBanner" class="new-dashboard-banner">
    <span v-if="offer.switchedOn">
      ✨ Try the <strong>new Dashboard</strong> — faster, cleaner, and built for you.
    </span>
    <span v-else>
      ✨ Charidy Internal beta — Try the <strong>new Dashboard</strong> — faster, cleaner, and built
      for you.
    </span>
    <a
      :href="newDashboardUrl"
      target="_blank"
      rel="noopener"
      class="banner-link"
      @click="rememberChoice"
    >
      Check it out →
    </a>
    <button class="banner-close" @click="dismiss">&times;</button>
  </div>
</template>

<script>
import { getCookie } from "@/helpers/cookie.js";
import {
  newDashboardOffer,
  loadNewDashboardOffer,
  dismissNewDashboardOffer,
  rememberNewDashboard,
} from "@/helpers/new-dashboard-offer.js";

export default {
  name: "NewDashboardBanner",

  props: {
    // The donor home: the banner is there only while it is an internal beta.
    internalBetaOnly: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      offer: newDashboardOffer,
      hasAdminToken: false,
    };
  },

  computed: {
    showBanner() {
      if (!this.offer.resolved || this.offer.dismissed) {
        return false;
      }
      if (this.offer.switchedOn) {
        return !this.internalBetaOnly;
      }
      return this.hasAdminToken;
    },

    newDashboardUrl() {
      return this.offer.url;
    },
  },

  mounted() {
    const token = getCookie("admin_token");
    this.hasAdminToken = !!token;
    loadNewDashboardOffer();
  },

  methods: {
    dismiss() {
      dismissNewDashboardOffer();
    },

    rememberChoice() {
      rememberNewDashboard(
        Number(this.$store.state.account.orgId || localStorage.getItem("orgId"))
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.new-dashboard-banner {
  margin-top: 90px;
  z-index: 10000;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  column-gap: 24px;
  padding: 8px 48px 8px 16px;
  background: linear-gradient(90deg, #6366f1, #8b5cf6);
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.4;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);

  @media only screen and (min-width: 1280px) {
    margin-top: 0;
    margin-inline-start: 300px;
  }
}

.banner-link {
  color: #fff;
  text-decoration: underline;
  font-weight: 700;
  white-space: nowrap;

  &:hover {
    color: #e0e7ff;
  }
}

.banner-close {
  position: absolute;
  right: 12px;
  background: none;
  border: none;
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  padding: 0 4px;
  line-height: 1;
  opacity: 0.7;

  &:hover {
    opacity: 1;
  }
}
</style>
